import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ScreenParams } from "@Types/login";
import { ReactComponent as BlueBalloon } from "../images/blue-balloon.svg";
import { ReactComponent as YellowBalloon } from "../images/yellow-balloon.svg";
import "./style.scss";

interface Props {
  params: ScreenParams;
}

const Welcome: FunctionComponent<Props> = ({ params }) => {
  const intl = useIntl();

  return (
    <div className="Welcome">
      <div className="Welcome-blueBalloon">
        <BlueBalloon className="Welcome-blueBalloon-image" />
      </div>
      <div className="Welcome-yellowBalloon">
        <YellowBalloon className="Welcome-yellowBalloon-image" />
      </div>
      <div className="Welcome-title">
        {intl.formatMessage(
          { id: `cheerz_LoginModal_${params.action}_welcome_title` },
          { name: params.firstName ? ` ${params.firstName}` : "" }
        )}
      </div>
    </div>
  );
};

export default Welcome;
